export default __webpack_public_path__ + "static/media/07e937f9-efe8-4fbb-b8c8-6e3bb3b4537e.2415a6f5.png";